/*
defines functionality for controlling user keyboard input
*/
import LinkView from '../view/link';
import GraphView from '../view/graph';
// import Typed from 'typed.js';

/**
 * represents a controller for keyboard input
 */
export default class KeyboardInputController {
    /**
     * makes a new input controller given a graph controller, model, and view
     * @param {GraphController} graphController the graph controller to use
     * @param {Graph} model the graph model instance to use
     * @param {GraphView} view the graph view to use
     */
    constructor(graphController, model, view) {
        this.graphController = graphController;
        this.model = model;
        this.view = view;

        this.initIntro(this.view);
        this.initHandlers();
    }

    /**
     *
     */
    initHandlers() {
        d3.select('body').on('keydown.new', () => this.onType());
    }

   /**
    * initializes a loading page instructions and beginning animation
    * fades away after 6 seconds in total
    *
    */
    initIntro(view) {

        let loadingbox = view.div.append('div').attr('id', 'loading-box');
        this.instructions1 = loadingbox.append('div')
                                            .text('This is a tool to turn ideas on their heads')
                                            .attr('id', 'instructions1');

         let introbox = view.div.append('div').attr('id', 'intro-box');
         this.introtext = introbox.append('div')
                             .text('Enter a word and double click to search for new perspectives')
                             .attr('id','introtext');

         this.showInputBoxAtLocation(650,300.5);
         d3.select('.box__input').onload = this.typeInput();

         d3.select('#instructions1')
             .style('opacity', 0)
             .transition().delay(2000).duration(1000)
             .style('opacity', 1)
             .transition().delay(2000).duration(1000)
             .style('opacity', 0);

         d3.select('#introtext')
             .style('opacity', 0)
             .transition().delay(6000).duration(1000)
             .style('opacity', 1)
             .transition().delay(8000)
             .style('opacity', 0);

         d3.select('.link-box')
            .style('opacity', 0)
            .style('y',((this.view.getCenter().y)+100))
            .transition().delay(6000).duration(700)
            .style('opacity', 1);

      if (loadingbox.style.opacity == 0){
        loadingbox.style.display = 'none';
      }

    }

    /**
    * for changing the text within the text inputBox
    *
    */
    typeInput() {
      var typed = new Typed(".box__input", {
        strings: ["chair","automation","dream",""],
        startDelay: 6500,
        typeSpeed: 220,
        backSpeed: 100,
        loop: false,
        smartBackspace: true,
        loopCount: Infinity
      });
    }

    /**
     * when user is typing
     * @param {*} d
     */
    onType() {
        // console.log('keydown new');
        let letterWasTyped = /^[a-zA-Z]$/g.test(d3.event.key);
        if (letterWasTyped) {
            this.showInputBoxAtLocation();
        } else if (d3.event.key === 'Enter') {
            this.submitInputBox();
        } else if (d3.event.key === 'Escape') {
            this.cancelInputBox();
            this.graphController.state.set('none');
        }
    }

    /**
     * if the state is adding, and the input box is there,
     * shows the input box at the given location
     * (also where the new node will appear)
     * @param {Number} [x] (optional) horizontal location of the input box
     * @param {Number} [y] (optional) vertical location of the input box
     */
    showInputBoxAtLocation(x = this.view.getCenter().x, y = this.view.getCenter().y) {
        let box = LinkView.inputBoxContainerSelection;
        console.log(box);
        let input = LinkView.inputBoxSelection;
        console.log(input)
        if (this.graphController.state.is('adding') && box.classed('new-on')) {
            box.classed('on new-on', true).raise();
            input.node().focus();
            input.node().select();
        } else if (this.graphController.state.isNot('typing') && this.graphController.state.isNot('connecting')) {
            this.graphController.state.set('typing');
            box.classed('on new-on', true)
                    .attr('x', x)
                    .attr('y', y)
                    .raise();
            input.node().focus();
            input.node().select();
        } else {

        }
    }

    /**
     * called when the enter button is pressed while typing in an input box
     * effect: makes a connector node, hides the input and resets the state
     *
     * if the typing state is on,
     * add a connector with the current value typed in, at the location of the box
     * hide the input box,
     * and reset the state
     *
     * ADDED: splits up phrase into separate connector nodes
     */
    submitInputBox() {
        if (this.graphController.state.is('typing')) {
            this.graphController.state.set('none');
            let box = LinkView.inputBoxContainerSelection;
            let input = LinkView.inputBoxSelection;
            let connections = input.node().value.split(' ');
            // splits multi-word-input into different connector nodes
            connections.forEach((word, idx) => {
                this.graphController.addConnectorNode(word, idx*word.length*50 + parseInt(box.attr('x')), box.attr('y'));
            });
            box.classed('on new-on', false);
            input.attr('value', '');
        }
    }

    /**
     * called when the escape button is pressed while typing in an input box
     * effect: hides the input and resets the state
     *
     * if the typing state is on,
     * hide the input box,
     * and reset the state
     */
    cancelInputBox() {
        if (this.graphController.state.is('typing')) {
            this.graphController.state.set('none');
            let box = LinkView.inputBoxContainerSelection;
            let input = LinkView.inputBoxSelection;
            box.classed('on new-on', false);
            input.attr('value', '');
        }
    }
}
